import type { ApiProblemKind } from '../../api/problem';
import type { Panel } from './panel-state';

/**
 * The failure copy the three CLM-39 panels on the Search quality surface
 * (Judgements, Boosts, Stability) share. The state machine itself is CLM-40's
 * `panel-state.ts` (`Panel<T>`, `toProblem`); the presentational pieces the four
 * CLM-40 panels share are in `panel.tsx`. This file adds only what CLM-39 needs
 * and exports no component, so fast refresh stays whole there.
 */

/** The problem branch of `Panel<T>`, named once for the CLM-39 panels' local state unions. */
export type PanelProblemState = Extract<Panel<never>, { kind: 'problem' }>;

/**
 * The `ErrorNotice` action slot for the three outcomes every CLM-39 panel must
 * present the same way: 501 names the endpoint (with its verb, since Stability
 * is a POST), 403 names the two roles that may read quality (G19), anything
 * unclassified offers Retry. Function form because the panels place it inside
 * an `ErrorNotice` they already render.
 */
export function panelProblemAction(problem: ApiProblemKind, endpoint: string, onRetry: () => void) {
  if (problem === 'not_implemented') {
    return (
      <p className="mut">
        The endpoint is <code>{endpoint}</code>; an empty panel here would be a false claim.
      </p>
    );
  }
  if (problem === 'forbidden') {
    return (
      <p className="mut">
        Search quality is read by <code>admin</code> and <code>legal_reviewer</code> (CEQ-Legal). Your sign-in was accepted; your role was
        not.
      </p>
    );
  }
  if (problem === 'unknown') {
    return (
      <button type="button" className="btn sm" onClick={onRetry}>
        Retry
      </button>
    );
  }
  return undefined;
}
